<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <p data-slot="section-header-description" :class="cn('mt-2 text-sm text-muted-fg', props.class)">
    <slot />
  </p>
</template>
